
var resized = false;
function adjustCalloutsHeight() {
    $j.each($j(".container .row"), function (i, row) {
        var featureMaxHeight = 0;
        $j(".feature-text", row).each(function () {
            var div = $j(this);
            var height = div.height();
            if (height > featureMaxHeight) {
                featureMaxHeight = height;
            }
        });
        $j(".feature-text", row).each(function () {
                $j(this).height(featureMaxHeight);
        });
    });
}

$j(document).ready(function () {
    $j(window).load(function () {
        adjustCalloutsHeight();
    });
});

function refreshOnOrientationchanged() {

    location.reload();
    adjustCalloutsHeight();

}
window.onorientationchange = refreshOnOrientationchanged;

